import { Link } from 'react-router'
import { Linkedin } from 'lucide-react'
import { cn } from '@/lib/utils'
import { CookiePreferencesLink } from '@/components/cookie-consent'

export const Footer = () => {
  return (
    <footer className="bg-[#0B0F19] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6 sm:gap-8 mb-8 sm:mb-10">
          <div className="text-center sm:text-left">
            <a href="/" className="inline-block mb-2">
              <h3 className="text-xl sm:text-2xl font-bold tracking-tight hover:text-orange-primary transition-colors duration-200">
                Benepicks
              </h3>
            </a>
            <p className="text-sm text-neutral-400">
              Modern health benefits for forward-thinking teams.
            </p>
          </div>

          <a
            href="https://www.linkedin.com/company/benepicks"
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              'w-10 h-10 rounded-full',
              'bg-white/5 border border-white/10',
              'flex items-center justify-center',
              'text-neutral-400',
              'hover:bg-orange-primary hover:border-orange-primary hover:text-white',
              'transition-all duration-300'
            )}
            aria-label="LinkedIn"
          >
            <Linkedin className="w-5 h-5" strokeWidth={2} />
          </a>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-neutral-500 text-xs sm:text-sm">
            © {new Date().getFullYear()} Benepicks. All rights reserved.
          </div>

          <div className="flex items-center gap-6">
            <a
              href="/blog"
              className="text-xs sm:text-sm text-neutral-500 hover:text-white transition-colors duration-200"
            >
              Blog
            </a>
            <Link
              to="/privacy"
              className="text-xs sm:text-sm text-neutral-500 hover:text-white transition-colors duration-200"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs sm:text-sm text-neutral-500 hover:text-white transition-colors duration-200"
            >
              Terms
            </Link>
            <CookiePreferencesLink className="text-xs sm:text-sm text-neutral-500 hover:text-white transition-colors duration-200" />
          </div>
        </div>
      </div>
    </footer>
  )
}
